// extracted by mini-css-extract-plugin
export default {"banner":"responsiveStyles_banner__3WKus"};